import React, { FC } from 'react';
import { Tag } from 'antd';

type Props = {
  value: string;
  options?: Record<string, string>;
};

export const StatusTag: FC<Props> = (props) => {
  const { value, options = { Active: 'green', Inactive: 'red' } } = props;
  return <Tag color={options[value] ?? 'default'}>{props.value}</Tag>;
};
